const mathJaxConfig = {
	loader: { load: ['[tex]/ams'] },
	tex: {
		packages: { '[+]': ['ams'] },
		inlineMath: [
			['$', '$'],
			['\\(', '\\)'],
		],
		displayMath: [
			['$$', '$$'],
			['\\[', '\\]'],
		],
	},
	options: {
		renderActions: {
			addMenu: [],
		},
	},
};

export default mathJaxConfig